import React from 'react';

//Components
import Input from '../form/new/Input';

//Constants
import { INPUT_TYPES } from '../form/constants/fieldTypes';

const AccessCode = (props)  => {

    return (
        <Input
            label={{
                labelText: props.labelText,
                isRequired: props.isRequired,
                labelClasses: props.labelClasses,
                wrapperClasses: props.wrapperClasses
            }}
            input={{
                id:'accessCode',
                name:'accessCode',
                inputClasses: props.inputClasses,
                type: INPUT_TYPES.TEXT,
                value: props.value,
                disabled: props.disabled,
                isInputRequired: props.isInputRequired,
                maxLength:props.maxLength,
                //onChange: props.onChange,
                validationType: props.validationType,
                onFocus: props.onFocus
            }}
            errors={{
                isErrorVisible: props.isErrorVisible,
                messageText: props.messageText,
                textReplacements: props.textReplacements,
                errorWrapperClasses: props.errorWrapperClasses,
                errorClasses: props.errorClasses,
            }}
            actions={{
                handleFieldChange: value => props.onChange({ target: { value, name:'accessCode' } }),
                handleFieldBlur: value => props.onBlur({ target: { value, name:'accessCode' } }),
                handleFieldFocus: value => props.onFocus({ target: { value, name:'accessCode' } }),
            }}
        />

    );
};


export default AccessCode;